import TextLoading from './TextLoading'

export default TextLoading
